// @ts-expect-error - Missing declaration file for conversations-message-history module
import { getTimestamp } from 'conversations-message-history/dates/operators/getters';
import { memo } from 'react';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import DashedLabel from '../../atoms/DashedLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const DateLabelMessage = /*#__PURE__*/memo(({
  message,
  labelPadding,
  locale
}) => {
  const timestamp = getTimestamp(message);
  const translatedDate = new Date(timestamp).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return /*#__PURE__*/_jsx(DashedLabel, {
    labelPadding: labelPadding,
    children: /*#__PURE__*/_jsx(VizExSmall, {
      use: "help",
      children: translatedDate
    })
  });
});
DateLabelMessage.displayName = 'DateLabelMessage';
export default DateLabelMessage;